export default __webpack_public_path__ + "static/media/today2.b74a2b0c.jpg";